/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import * as _ from 'lodash';

import DatePickerToggle from '../../../components/DatePickerToggle';
import { Caption } from '../../../components/Text';
import { Age } from '../../../localization/LocalizedDate';
import DateUtil from '../../../../utilities/DateUtil';
import Card, { CardSection } from '../../../components/card/Card';
import { ConnectedGrayPrivacyCard } from '../../../components/card/PrivacyCard';
import { ScrollAwareScroller } from '../../../components/ScrollAware';
import { AppHeaderScrollableText } from '../../../components/appNav/AppHeaderScrollable';
import ContentWrapper from '../../../components/ContentWrapper';
import { PolicyName } from '../../../../models/PolicyModel';
import ProfileModel from '../../../../models/ProfileModel';

class ProfileDateOfBirth extends React.Component {

  constructor(props) {
    super(props);

    this.handleDateChange = this.handleDateChange.bind(this);
    this.displayTerms = this.displayTerms.bind(this);

    this.state = {
      showTerms: false,
    };
  }

  handleDateChange(dateData) {
    const newProfileData = _.assign({}, this.props.profileData, {
      date_of_birth: dateData.date,
    });
    this.props.onChange(newProfileData);
  }

  displayTerms() {
    this.setState({ showTerms: true });
  }

  render() {
    const profile = new ProfileModel(this.props.profileData);
    const dob = this.props.profileData.date_of_birth || '';
    const isDependentProfile = profile.isDependent();

    return (
      <ScrollAwareScroller>
        <AppHeaderScrollableText {...this.props.title} />

        <ContentWrapper>

          <ConnectedGrayPrivacyCard
            name={PolicyName.DATE_OF_BIRTH}
            subTitle="privacy.privacyBlock.dateOfBirth.teaser"
            onWithdrawConsent={this.props.onWithdrawConsent}
          />

          <Card>
            <CardSection>
              <form onSubmit={this.onChange}>
                <div>
                  <DatePickerToggle
                    label={this.props.phraseData.dateOfBirthFieldLabel}
                    date={dob}
                    precision="P1D"
                    name="date_of_birth"
                    onChange={this.handleDateChange}
                    invalidHint={this.props.submitErrorText}
                    initialFocus={!dob}
                    displayFormat="long"
                    latestDateLimit={isDependentProfile ? DateUtil.add(DateUtil.today(), 9, 'months') : DateUtil.today()}
                  >

                    {
                      dob ? (
                        <Caption>
                          <Age dateOfBirth={this.props.profileData.date_of_birth} />
                        </Caption>
                      ) : null
                    }

                  </DatePickerToggle>
                </div>

                <input type="submit" style={{ visibility: 'hidden', display: 'none' }} />
              </form>
            </CardSection>
          </Card>

        </ContentWrapper>

      </ScrollAwareScroller>
    );
  }
}
ProfileDateOfBirth.propTypes = {
  title: PropTypes.object,
  phraseData: PropTypes.object,
  profileData: PropTypes.object.isRequired,
  submitForm: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  submitErrorText: PropTypes.any,
  isInitialSetup: PropTypes.bool.isRequired,
  onWithdrawConsent: PropTypes.func,
};

export default ProfileDateOfBirth;
